import React, { FC, useEffect, useState } from 'react';
import { find, findIndex, map, some } from 'lodash';
import { Text, Checkbox, Box, Icon, IconSize, TextFieldSize, MenuOptions, Menu } from '@bechtel/gds';
import { markerFilters } from '../form-state';
import { MapFiltersProps } from './types';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { MenuButtonStyled, MenuItemStyled, PopperContainerStyled, FilterIconStyled } from './styled';
import { MarkerFilter, MarkerType } from '../types';

export const MapFilters: FC<MapFiltersProps> = ({
  markerTypes,
  onFilterChange,
  selectedMarkerTypes,
  setSelectedMarkerTypes,
}) => {
  const { i18n } = useLingui();

  useEffect(() => {
    if (!onFilterChange) return;
    onFilterChange(selectedMarkerTypes);
  }, [onFilterChange, selectedMarkerTypes]);

  return (
    <Box css={{ position: 'relative' }}>
      <Menu>
        {({ isOpen, toggle, close: closeMenu }) => (
          <div
            onBlur={() => {
              closeMenu();
            }}
          >
            <MenuButtonStyled
              data-testid="weld-more-button"
              onClick={() => {
                toggle();
              }}
              size={TextFieldSize.SMALL}
            >
              <Icon icon="tasks" size={IconSize.SMALL} fillColor="blue.800" />
            </MenuButtonStyled>
            <PopperContainerStyled>
              {isOpen && (
                <MenuOptions
                  css={`
                    order: 2;
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;
                  `}
                >
                  <MenuItemStyled
                    onMouseDown={(event) => {
                      if (selectedMarkerTypes?.length !== markerFilters.length) {
                        setSelectedMarkerTypes(map(markerFilters, 'value'));
                      } else {
                        setSelectedMarkerTypes([]);
                      }

                      event.preventDefault();
                    }}
                  >
                    <Box mr={{ sm: '450' }}>
                      <Checkbox
                        data-testid="search-by-all"
                        checked={selectedMarkerTypes.length == markerFilters.length}
                        indeterminate={
                          selectedMarkerTypes.length > 0 && selectedMarkerTypes.length < markerFilters.length
                        }
                        readOnly
                      />
                    </Box>
                    <Text size="400" weight="600" color="bechtel.grey.1000">
                      <Trans>Select All</Trans>
                    </Text>
                  </MenuItemStyled>
                  <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }}>
                    {map(markerTypes, (item: MarkerType) => {
                      const markerFilter = find(markerFilters, (markerFilterItem: MarkerFilter) => {
                        return markerFilterItem.value === item;
                      });
                      return (
                        <MenuItemStyled
                          key={item}
                          onMouseDown={(event) => {
                            const selected = findIndex(selectedMarkerTypes, (selectedItem) => {
                              return item === selectedItem;
                            });
                            if (selected !== -1) {
                              const updatedMarkerTypes = [...selectedMarkerTypes];
                              updatedMarkerTypes.splice(selected, 1);
                              setSelectedMarkerTypes([...updatedMarkerTypes]);
                            } else {
                              setSelectedMarkerTypes([...selectedMarkerTypes, item]);
                            }
                            event.preventDefault();
                          }}
                        >
                          <Box
                            flexGrow={{ sm: 1 }}
                            alignItems={{ sm: 'center' }}
                            justifyContent={{ sm: 'space-between' }}
                          >
                            <Box>
                              <Box mr={{ sm: '500' }}>
                                <Checkbox
                                  checked={some(selectedMarkerTypes, (selecetdItem) => {
                                    return item === selecetdItem;
                                  })}
                                  readOnly
                                />
                              </Box>
                              {markerFilter && markerFilter.label && (
                                <Text size="400" color="bechtel.grey.1000">
                                  {i18n._(markerFilter.label)}
                                </Text>
                              )}
                            </Box>
                            {markerFilter && markerFilter.icon && <FilterIconStyled src={markerFilter.icon} />}
                          </Box>
                        </MenuItemStyled>
                      );
                    })}
                  </Box>
                </MenuOptions>
              )}
            </PopperContainerStyled>
          </div>
        )}
      </Menu>
    </Box>
  );
};
